import { createRouter, createWebHashHistory, createWebHistory, useRoute } from 'vue-router'

import App from "@/services/App";
// import Base from "@/layouts/Base.vue";
import Empty from "@/layouts/Empty.vue";
import Dashboard from "@/layouts/Dashboard.vue";

// import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import Logout from "@/views/Logout.vue";
import Forgot from '@/views/Forgot.vue';
import Register from '@/views/Register.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import NotFound from '@/views/NotFound.vue';
import InvoiceWebView from '@/components/Payments/InvoiceWebView.vue';


import ProjectStatusDatatable from '@/components/Projects/ProjectStatusDatatable.vue';

import Cache from "@/services/Cache";
import Events from "@/services/Emitter";
import TokenHelper from "@/services/TokenHelper";

import Home from '@/components/Dashboard/Home.vue';

import DashRoutes from "./DashRoutes";

import ClockRoutes from "./ClockRoutes";
import TimeRoutes from "./TimeRoutes";
import PartRoutes from './PartRoutes';
import PMRoutes from './PMRoutes';
import ExpenseRoutes from './ExpenseRoutes';
import TechRoutes from './TechRoutes';
import NoteRoutes from './NoteRoutes';
import ClientRoutes from './ClientRoutes';
import JobRoutes from './JobRoutes';
import MileageRoutes from './MileageRoutes';
import StaffRoutes from "./StaffRoutes";
import WorkOrderRoutes from "./WorkOrderRoutes";
import EstimateRoutes from "./EstimateRoutes";
import RequestsRoutes from "./RequestsRoutes";
import AdminRoutes from "./AdminRoutes";
import NotificationRoutes from "./NotificationRoutes";

import ProjectRoutes from "./ProjectRoutes";
import ReportRoutes from "./ReportRoutes";
import CalendarRoutes from "./CalendarRoutes";
import FormRoutes from "./FormRoutes";
import SettingsRoutes from "./SettingsRoutes";
import PaymentRoutes from "./PaymentRoutes";

// LAZY LOAD: component: () => import('../views/... .vue'),

// store window history
const  historyLength = window.history.length;

const router = createRouter({
    history: createWebHashHistory(), // createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'root',
            components: {
                default: Dashboard,
            },
            children: [

                ...ClockRoutes,
                ...ProjectRoutes,
                ...ReportRoutes,
                ...CalendarRoutes,
                ...StaffRoutes,
                ...TimeRoutes,
                ...PartRoutes,
                ...PMRoutes,
                ...ExpenseRoutes,
                ...TechRoutes,
                ...NoteRoutes,
                ...ClientRoutes,
                ...JobRoutes,
                ...MileageRoutes,
                ...RequestsRoutes,
                ...WorkOrderRoutes,
                ...EstimateRoutes,
                ...AdminRoutes,
                ...NotificationRoutes,
                ...FormRoutes,
                ...SettingsRoutes,
                ...PaymentRoutes,
                
                ...DashRoutes,
            ]
        },
        

        {
            path: "/logout",
            name: "Logout",
            components: {
                default: Empty,
            },
            children: [
                {
                    path: "",
                    components: {
                        page: Logout
                    }
                }
            ]
        },

        {
            path: "/login",
            name: "Login",
            components: {
                default: Empty,
            },
            children: [
                {
                    path: "",
                    components: {
                        page: Login
                    }
                }
            ]
        },

        {
            path: "/forgot-password",
            name: "Forgot Password",
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: Forgot
                    }
                }
            ]
        },

        {
            path: "/register",
            name: "Register",
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: Register
                    }
                }
            ]
        },

        {
            path: "/password/reset/:token",
            name: "Reset Password",
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: ResetPassword
                    }
                }
            ]
        },

        {
            path: "/our-projects",
            name: "Our Projects",
            meta: {
                requiresAuth: true
            },
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: ProjectStatusDatatable
                    }
                }
            ]
        },

        {
            path: "/invoice/:invoiceId/:hash",
            name: "Invoice Web View",
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: InvoiceWebView
                    }
                }
            ]
        },

        {
            path: "/redirect/:to*",
            name: "Redirect",
            component: () => 
            {
                return import("@/components/UI/KtRedirect.vue");
            }
        },

        {
            path: "/public/form/:secretKey",
            name: "PublicForm",
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: () => import("@/views/PublicForm.vue")
                    }
                }
            ]
        },

        // Catch-all route for 404 Not Found
        {
            path: "/:pathMatch(.*)*",
            name: "NotFound",
            components: {
                default: Empty
            },
            children: [
                {
                    path: "",
                    components: {
                        page: NotFound
                    }
                }
            ]
        }
    ],
});


router.beforeEach(async (to, from, next) => {

    console.debug("to", to, "from", from);

    App.initialize();

    

    if (to.meta.requiresAuth) {
        let user = await Cache.get("radar_user");

        if (!user) {
            return next("/login");
        }
    }

    // Check if route requires admin privileges
    if (to.meta.requiresAdmin) {
        const isAdmin = await TokenHelper.isSystemAdmin();
        
        if (!isAdmin) {
            console.warn("Access denied: Admin privileges required");
            alert("Access denied. You must be a system administrator to access this area.");
            return next("/home");
        }
    }

    const appElement = document.getElementById("app") as HTMLElement | null;
    
    if (appElement)
    {
        // alert(JSON.stringify(to));
        let rt = to.matched && to.matched[0] && to.matched[0].name;
        if (typeof rt === "string")
        {
            rt = rt.replaceAll(/[A-Z]/g, (match) => match.toLowerCase());
            rt = rt.replaceAll(/[^a-z]/g, (match) => "-");
            appElement.className = rt;
        }
        else 
        {
            appElement.className = "nameless";
        }
    }
    return next();
});

// todo ... store the history in the session cache and not local storage

Events.on("redirect", (path:string) => 
{
    path = ("/redirect/" + path + "").replace(/\/\//g, "/");
    window.setTimeout(() =>
    {
        router.push({
            path: path
        });
    }, 30);
});

Events.on("back", () =>
{
    if (historyLength < window.history.length)
    {
        window.setTimeout(() =>
        {
            router.back();
        }, 30);
    }

    else
    {
        // take them to the homepage ?
        router.push({
            path: "/"
        });
    }
});

export default router
